import { AxiosError } from 'axios';
import { Classification } from '../classification/types';

export enum RatingTypes {
    SET_COURSE_RATE_REQUEST = '@rating/SET_COURSE_RATE_REQUEST',
    SET_COURSE_RATE_SUCCESS = '@rating/SET_COURSE_RATE_SUCCESS',
    SET_COURSE_RATE_FAILURE = '@rating/SET_COURSE_RATE_FAILURE',
    SET_CONTENT_RATE_REQUEST = '@rating/SET_CONTENT_RATE_REQUEST',
    SET_CONTENT_RATE_SUCCESS = '@rating/SET_CONTENT_RATE_SUCCESS',
    SET_CONTENT_RATE_FAILURE = '@rating/SET_CONTENT_RATE_FAILURE',
    SET_PROGRAM_RATE_REQUEST = '@rating/SET_PROGRAM_RATE_REQUEST',
    SET_PROGRAM_RATE_SUCCESS = '@rating/SET_PROGRAM_RATE_SUCCESS',
    SET_PROGRAM_RATE_FAILURE = '@rating/SET_PROGRAM_RATE_FAILURE',
    GET_RATE_REQUEST = '@rating/GET_RATE_REQUEST',
    GET_RATE_SUCCESS = '@rating/GET_RATE_SUCCESS',
    GET_RATE_FAILURE = '@rating/GET_RATE_FAILURE',
    CLEAR_RATE = '@rating/CLEAR_RATE',
}

export interface RateData {
    entityId: number;
    contentTitle: string;
    criteriaId: string;
    criteriaTitle: string;
    rating: number;
    personId: number;
    classifications: Classification[];
    classEnrollmentId?: number;
}

export interface RatingState {
    data: RateData;
    loading: boolean;
    error?: AxiosError;
    submittedRating: boolean;
    errorOnSubmit: boolean;
}
